var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconYoutube = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "youtube",
    width: 34.372,
    height: 25.004,
    viewBox: "0 0 34.372 25.004",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5221",
    "data-name": "Group 5221",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6663",
    "data-name": "Path 6663",
    d: "M17.181,24c1.026,0,10.1.018,12.656.642a5.445,5.445,0,0,1,3.828,3.908,43.061,43.061,0,0,1,.7,7.99,43.03,43.03,0,0,1-.681,7.764,5.457,5.457,0,0,1-3.8,3.988C27.3,48.985,18.209,49,17.181,49S7.066,48.985,4.5,48.3A5.447,5.447,0,0,1,.71,44.556,42.875,42.875,0,0,1,0,36.522,43.022,43.022,0,0,1,.678,28.7a5.457,5.457,0,0,1,3.8-3.988C7.066,24.02,16.154,24,17.181,24Zm0,22.14c3.885,0,10.273-.163,11.946-.61A2.548,2.548,0,0,0,30.887,43.7a40.254,40.254,0,0,0,.616-7.166,40.246,40.246,0,0,0-.636-7.384,2.532,2.532,0,0,0-1.759-1.74c-1.832-.446-9.233-.547-11.926-.547-3.885,0-10.273.163-11.946.61A2.548,2.548,0,0,0,3.476,29.3a40.25,40.25,0,0,0-.616,7.221A40.251,40.251,0,0,0,3.5,43.91a2.542,2.542,0,0,0,1.747,1.623C6.909,45.978,13.3,46.14,17.181,46.14Z",
    transform: "translate(0.005 -24)",
    fill: "#737bbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6664",
    "data-name": "Path 6664",
    d: "M71.432,72.07A1.432,1.432,0,0,1,70,70.638V61.272a1.432,1.432,0,0,1,2.14-1.245l8.235,4.683a1.432,1.432,0,0,1,0,2.49L72.14,71.883A1.431,1.431,0,0,1,71.432,72.07Zm1.432-8.336v4.442l3.906-2.221Z",
    transform: "translate(-57.468 -53.424)",
    fill: "#737bbb"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconYoutube, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-youtube.ccdd9e59.svg";
export { ForwardRef as ReactComponent };